enum MapScale {
  State = 'State',
  Dma = 'DMA',
  County = 'County',
  Zip = 'ZIP',
  CongressionalDistricts = 'Congressional Districts',
  City = 'City',
}

export default MapScale;
